import { render, staticRenderFns } from "./Superiority.vue?vue&type=template&id=87f6860a&scoped=true"
import script from "./Superiority.vue?vue&type=script&lang=js"
export * from "./Superiority.vue?vue&type=script&lang=js"
import style0 from "./Superiority.vue?vue&type=style&index=0&id=87f6860a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f6860a",
  null
  
)

export default component.exports